import React, { useCallback } from 'react';
import { Keyboard, TouchableOpacity, View } from 'react-native';
import Text from 'design-system/Text';
import { hitSlopS, rem, Spacer } from 'design-system';
import IconTooltip from 'design-system/icons/IconTooltip';
import BlurAmountView from 'design-system/BlurAmountView';
import IconEmmaWallet from 'design-system/icons/IconEmmaWallet';
import useStyles from 'hooks/useStyles';
import Modal from 'utils/packages/Modal';
import { useAppSelector } from 'store/hooks';
import { formatAmount } from 'utils/formatting';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import { selectTradingAccount } from 'features/invest/reducers/selectors';
import { AccountTypeDisplayLong } from 'features/invest/constants';
const TransferSecclRow = ({ useCashAsTitle, }) => {
    const styles = useStyles(styleSet);
    const account = useAppSelector(selectTradingAccount);
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    const onInfoButtonPress = useCallback(() => {
        Keyboard.dismiss();
        Modal.showConfirmation({
            title: 'Available',
            subtitle: `These are the funds available right now in the ${AccountTypeDisplayLong[account?.account.accountType || 'GIA']}. It may be lower than your total balance if you have money pending from recent transfers or investments.`,
            confirmButtonTitle: 'Okay',
        });
    }, [account?.account.accountType]);
    if (account?.account.broker !== 'seccl') {
        return null;
    }
    return (<TouchableBounceCard onDark disabled noMarginTop noMarginBottom style={styles.cardBtn}>
      <View style={styles.row}>
        <IconEmmaWallet size={rem(44)}/>
        <Spacer w={16}/>
        <View style={styles.flex}>
          <Text Text-16 numberOfLines={1}>
            {useCashAsTitle
            ? 'Cash'
            : AccountTypeDisplayLong[account.account.accountType]}
          </Text>
          <View style={styles.row}>
            <Text TextThin-14 Secondary>
              Available{' '}
            </Text>
            <BlurAmountView enabled={scrambled}>
              <Text NumbersThin-14 Secondary>
                {formatAmount(account.account.availableToInvest?.value || 0, account.account.currency, 2)}
              </Text>
            </BlurAmountView>
            <Spacer w={4}/>
            <TouchableOpacity onPress={onInfoButtonPress} hitSlop={hitSlopS}>
              <IconTooltip colorKey="secondary" width={16} height={16}/>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </TouchableBounceCard>);
};
const styleSet = createStyleSheets(() => ({
    cardBtn: {
        paddingVertical: rem(24),
        paddingHorizontal: rem(16),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    flex: {
        flex: 1,
    },
}));
export default TransferSecclRow;
